import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import {
    InterviewQuestionDisplayOptions,
    InterviewQuestionTypeModeDisplayOptions,
} from '@app/types/translatables/applicant-tracker/interview-question-display.options';

@Component({
    selector: 'app-job-posting-interview-questions-card',
    templateUrl: './job-posting-interview-questions-card.template.html',
    styleUrls: ['./job-posting-interview-questions-card.style.scss'],
})
export class JobPostingInterviewQuestionsCardComponent {
    @Input() interviewQuestions: InterviewQuestion[];
    @Output() onInterviewQuestionsChanged: EventEmitter<InterviewQuestion[]> = new EventEmitter<InterviewQuestion[]>();

    openQuestionDialog = false;
    isDeleteInterviewQuestionDialogOpen = false;

    interviewQuestionToEdit: InterviewQuestion;

    InterviewQuestionDisplay = InterviewQuestionDisplayOptions;
    InterviewQuestionTypeModeDisplay = InterviewQuestionTypeModeDisplayOptions;

    drop(event: CdkDragDrop<InterviewQuestion[]>): void {
        moveItemInArray(this.interviewQuestions, event.previousIndex, event.currentIndex);
        this.updateInterviewQuestionIndexes();
    }

    editInterviewQuestion(interviewQuestion: InterviewQuestion): void {
        this.interviewQuestions[this.interviewQuestions.indexOf(this.interviewQuestionToEdit)] = interviewQuestion;
        this.closeInterviewQuestionDialog();
    }

    openEditInterviewQuestionDialog(interviewQuestion: InterviewQuestion): void {
        this.openQuestionDialog = true;
        this.interviewQuestionToEdit = interviewQuestion;
    }

    openDeleteInterviewQuestionDialog(interviewQuestion: InterviewQuestion): void {
        this.interviewQuestionToEdit = interviewQuestion;
        this.isDeleteInterviewQuestionDialogOpen = true;
    }

    closeDeleteInterviewQuestionDialog(): void {
        this.isDeleteInterviewQuestionDialogOpen = false;
        this.interviewQuestionToEdit = null;
    }

    async deleteInterviewQuestion(): Promise<void> {
        if (this.interviewQuestionToEdit.id) {
            await this.interviewQuestionToEdit.delete();
        }
        this.interviewQuestions.splice(this.interviewQuestions.indexOf(this.interviewQuestionToEdit), 1);
        this.onInterviewQuestionsChanged.emit(this.interviewQuestions);
        this.closeDeleteInterviewQuestionDialog();
    }

    closeInterviewQuestionDialog(): void {
        this.openQuestionDialog = false;
        this.interviewQuestionToEdit = null;
    }

    private updateInterviewQuestionIndexes(): void {
        this.onInterviewQuestionsChanged.emit(
            this.interviewQuestions.map((interviewQuestion, index) => {
                interviewQuestion.questionIndex = index;
                return interviewQuestion;
            })
        );
    }
}
